module.exports = __webpack_public_path__ + "static/media/check.02468086.svg";